import React from "react";

const Spinner = () => (
    <div className="spinner">
        <i className="icon-spinner icon-3x" />
    </div>
);

export function wrapLazy(Component: any) {
    const componentWrapper = (props: any) => (
        <React.Suspense fallback={<Spinner />}>
            <Component {...props} />
        </React.Suspense>
    );

    if (Component && Component.displayName) {
        componentWrapper.displayName = Component.displayName;
    } else {
        componentWrapper.displayName = "LazyComponentWrapper";
    }

    return componentWrapper;
}
